import { useCallback, useRef } from 'react';
import { TagsAutoCompleteInputRefProps } from '../TagsAutocompleteInput';

export const useTagsAutoCompleteApi = () => {
  const tagsAutocompleteRef = useRef<TagsAutoCompleteInputRefProps>(null);

  const saveTags = useCallback(async () => {
    await tagsAutocompleteRef.current?.saveTags();
  }, []);

  const resetTags = useCallback(() => {
    tagsAutocompleteRef.current?.resetTags();
  }, []);

  return [
    tagsAutocompleteRef,
    {
      saveTags,
      resetTags,
    },
  ] as const;
};
